export default __webpack_public_path__ + "static/media/icon-attach.d6b8add4.svg";